"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var locales_1 = __importDefault(require("../locale/locales"));
var DEFAULT_TEMPLATE = '{symbol} {negative}{amount}';
var DEFAULT_FORMAT_CONFIG = {
    integerOnly: false,
    separationCount: 3,
    separator: ',',
    negativeMark: '-',
};
var getTemplate = function (code, config, locale) {
    var symbol = (config[locale] && config[locale].symbol) || code.toUpperCase();
    var template = (config[locale] && config[locale].template) || DEFAULT_TEMPLATE;
    return template.replace('{symbol}', symbol);
};
var createCurrency = function (code, config, formatConfig) {
    if (config === void 0) { config = {}; }
    if (formatConfig === void 0) { formatConfig = DEFAULT_FORMAT_CONFIG; }
    return ({
        localizeConfig: locales_1.default.reduce(function (acc, locale) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[locale] = getTemplate(code, config, locale), _a)));
        }, {}),
        formatConfig: formatConfig,
        getLocalizeTemplate: function (locale) {
            return getTemplate(code, config, locale);
        },
    });
};
var USD = createCurrency('USD', {
    en_US: { symbol: '$', template: '{negative}{symbol}{amount}' },
});
var CAD = createCurrency('CAD', {
    en_US: { template: '{negative}{symbol} {amount}' },
    en_CA: { symbol: '$', template: '{negative}{symbol} {amount}' },
    fr_CA: { symbol: '$' },
});
var AUD = createCurrency('AUD', { en_AU: { symbol: '$' } });
var EUR = createCurrency('EUR');
var CNY = createCurrency('CNY', { zh_CN: { symbol: '¥' } }); // Enhanced
var NZD = createCurrency('NZD');
var GBP = createCurrency('GBP', {
    en_GB: { symbol: '£' },
    cy_GB: { symbol: '£' },
});
var BRL = createCurrency('BRL');
// const CLP = createCurrency('CLP') // Duplicate
var DKK = createCurrency('DKK'); // Enhanced?
var HKD = createCurrency('HKD');
var IDR = createCurrency('IDR');
var JPY = createCurrency('JPY', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var MYR = createCurrency('MYR');
var MXN = createCurrency('MXN');
var NOK = createCurrency('NOK');
var PAB = createCurrency('PAB');
var PLN = createCurrency('PLN');
var PHP = createCurrency('PHP');
var SGD = createCurrency('SGD');
var ZAR = createCurrency('ZAR');
var LKR = createCurrency('LKR');
var SEK = createCurrency('SEK');
var CHF = createCurrency('CHF');
var TWD = createCurrency('TWD');
var THB = createCurrency('THB');
var BIF = createCurrency('BIF', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var BYR = createCurrency('BYR', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var CLF = createCurrency('CLF', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var CLP = createCurrency('CLP', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var CVE = createCurrency('CVE', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var DJF = createCurrency('DJF', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var GNF = createCurrency('GNF', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var ISK = createCurrency('ISK', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var KMF = createCurrency('KMF', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var KRW = createCurrency('KRW', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var PYG = createCurrency('PYG', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var RWF = createCurrency('RWF', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var UGX = createCurrency('UGX');
var UYI = createCurrency('UYI', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var VND = createCurrency('VND');
var VUV = createCurrency('VUV', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var XAF = createCurrency('XAF', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var XPF = createCurrency('XPF', {}, __assign(__assign({}, DEFAULT_FORMAT_CONFIG), { integerOnly: true }));
var RMB = createCurrency('RMB', { zh_CN: { symbol: '¥' } });
var currenciesConfig = {
    USD: USD,
    CAD: CAD,
    AUD: AUD,
    EUR: EUR,
    CNY: CNY,
    NZD: NZD,
    GBP: GBP,
    BRL: BRL,
    DKK: DKK,
    HKD: HKD,
    IDR: IDR,
    JPY: JPY,
    MYR: MYR,
    MXN: MXN,
    NOK: NOK,
    PAB: PAB,
    PLN: PLN,
    PHP: PHP,
    SGD: SGD,
    ZAR: ZAR,
    LKR: LKR,
    SEK: SEK,
    CHF: CHF,
    TWD: TWD,
    THB: THB,
    BIF: BIF,
    BYR: BYR,
    CLF: CLF,
    CLP: CLP,
    CVE: CVE,
    DJF: DJF,
    GNF: GNF,
    ISK: ISK,
    KMF: KMF,
    KRW: KRW,
    PYG: PYG,
    RWF: RWF,
    UGX: UGX,
    UYI: UYI,
    VND: VND,
    VUV: VUV,
    XAF: XAF,
    XPF: XPF,
    RMB: RMB,
};
exports.default = currenciesConfig;
